<cm-base-dialog (closeDialog)="onCancel()">
	<div
		cdkDrag
		cdkDragHandle
		cdkDragRootElement=".cdk-overlay-pane"
		cm-dialog-title
	>
		Add New Tenant
	</div>
	<div cm-dialog-body>
		<!-- Alert -->
		@if (showAlert) {
		<fuse-alert
			class="mb-4"
			[appearance]="'outline'"
			[showIcon]="false"
			[type]="alert.type"
			[@shake]="alert.type === 'error'"
		>
			{{ alert.message }}
		</fuse-alert>
		}

		<!-- Form -->
		<form [formGroup]="newUserForm">
			<!-- First Name -->
			<div>
				<mat-form-field class="w-full">
					<mat-label>First Name</mat-label>
					<input
						[formControlName]="'firstName'"
						matInput
						placeholder="First Name"
						maxlength="50"
					/>
					@if ( newUserForm.get('firstName').hasError('required') ) {
					<mat-error> First name is required </mat-error>
					}
				</mat-form-field>
			</div>
			<!-- Last Name -->
			<div>
				<mat-form-field class="w-full">
					<mat-label>Last Name</mat-label>
					<input
						[formControlName]="'lastName'"
						matInput
						placeholder="Last Name"
						maxlength="50"
					/>
					@if (newUserForm.get('lastName').hasError('required')) {
					<mat-error> Last name is required </mat-error>
					}
				</mat-form-field>
			</div>
			<!-- Email -->
			<div>
				<mat-form-field class="w-full">
					<mat-label>Email</mat-label>
					<input
						[formControlName]="'email'"
						matInput
						type="email"
						placeholder="Email"
						maxlength="100"
					/>
					@if (newUserForm.get('email').hasError('required')) {
					<mat-error> Email address is required </mat-error>
					} @if (newUserForm.get('email').hasError('email')) {
					<mat-error> Must be a valid email address </mat-error>
					}
				</mat-form-field>
			</div>
			<!-- Role -->
			<div>
				<mat-form-field class="w-full">
					<mat-label>Role</mat-label>
					<mat-select
						[formControlName]="'role'"
						#roleSelect="matSelect"
					>
						<mat-select-trigger class="text-md">
							<span class="ml-1 font-medium">{{
								roleSelect.value
							}}</span>
						</mat-select-trigger>
						@for (role of roles$() |
						sortArray:'name':'string':'asc'; track role) {
						<mat-option
							class="h-auto py-4 leading-none"
							[value]="role.name"
						>
							<div class="font-medium">
								{{ role.name }}
							</div>
							<div
								class="mt-1.5 text-sm whitespace-normal leading-normal text-secondary"
							>
								{{ role.description }}
							</div>
						</mat-option>
						}
					</mat-select>
					@if (newUserForm.get('role').hasError('required')) {
					<mat-error> Role is required </mat-error>
					}
				</mat-form-field>
			</div>
		</form>
	</div>
	<div cm-dialog-footer>
		<button mat-stroked-button (click)="onCancel()">Cancel</button>
		<button
			class="ml-2"
			mat-flat-button
			(click)="onSave()"
			[color]="'primary'"
			[disabled]="newUserForm.pristine || newUserForm.invalid"
		>
			{{ config.submitLabel }}
		</button>
	</div>
</cm-base-dialog>
